var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconEditMulticolor = function IconEditMulticolor(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M48.054 56.333a2.825 2.825 0 012.816 2.835 2.824 2.824 0 01-2.816 2.835 2.824 2.824 0 01-2.815-2.835 2.825 2.825 0 012.815-2.835zM36.794 56.333a2.825 2.825 0 012.815 2.835 2.824 2.824 0 01-2.815 2.835 2.824 2.824 0 01-2.815-2.835 2.825 2.825 0 012.815-2.835z",
    fill: "#F71414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7 1.685a10.24 10.24 0 017.742 1.73c4.68 3.299 5.822 9.817 2.545 14.53L28.937 52.49 9.143 62.476 11.97 40.51 36.014 5.975a10.289 10.289 0 016.687-4.29z",
    fill: "#FFC446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7 1.685a10.24 10.24 0 017.742 1.73c4.68 3.299 5.822 9.817 2.545 14.53L28.937 52.49l-3.338-.794a20 20 0 01-13.022-10.049l-.606-1.137L36.014 5.975a10.289 10.289 0 016.687-4.29z",
    fill: "#F71414"
  }));
};

IconEditMulticolor.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconEditMulticolor;
//# sourceMappingURL=IconEditMulticolor.js.map